/**
 * lp-bead-modal.js — UX de la modale « Choisir une pierre » (design validé)
 * - Tri A→Z des rangées de l'onglet « Toutes »
 * - Onglets Toutes / Corps / Esprit
 * - Recherche à volet : tous les besoins (triés) + pierres par nom
 * - Filtre par besoin avec pastille effaçable
 * - Récaps des accordéons Taille / Mes pierres
 * - Prix total répliqué dans le bouton Ajouter au panier
 *
 * La sélection d'une pierre reste 100% gérée par bead-selector.js : ce script
 * se contente de cliquer les .bead-option existants (aucune logique panier ici).
 *
 * Chargé via le bloc (page produit statique) + garde d'initialisation.
 */
(function () {
  'use strict';

  if (window.__lpBeadModalInit) return;
  window.__lpBeadModalInit = true;

  var fold = function (s) {
    return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  };
  var frSort = function (a, b) { return a.localeCompare(b, 'fr'); };

  function init() {
    var modals = document.querySelectorAll('.lp-modal');
    if (!modals.length) { setTimeout(init, 300); return; }

    modals.forEach(setupModal);
    setupRecaps();
    setupCtaPrice();
  }

  // ---------------------------------------------------------------- modales
  function setupModal(modal) {
    var listPane = modal.querySelector('[data-lp-pane="toutes"] .lp-list');

    // Tri A→Z des rangées (réordonner le DOM conserve les écouteurs)
    if (listPane) {
      var rows = Array.prototype.slice.call(listPane.querySelectorAll('.bead-option'));
      rows.sort(function (a, b) { return frSort(a.dataset.beadName || '', b.dataset.beadName || ''); });
      rows.forEach(function (r) { listPane.appendChild(r); });
    }

    // Onglets
    modal.querySelectorAll('.lp-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        modal.querySelectorAll('.lp-tab').forEach(function (t) { t.classList.toggle('is-on', t === tab); });
        modal.querySelectorAll('.lp-pane').forEach(function (p) { p.hidden = p.dataset.lpPane !== tab.dataset.lpTab; });
      });
    });

    // Recherche à volet
    var q = modal.querySelector('.lp-q');
    var drop = modal.querySelector('.lp-drop');
    var filterbar = modal.querySelector('.lp-filterbar');

    function stoneNames() {
      return Object.keys((window.beadSelectorData || {}).combinaisons || {}).sort(frSort);
    }
    function needs() {
      var n = window.lpNeeds || { corps: [], esprit: [] };
      return { corps: n.corps.slice().sort(frSort), esprit: n.esprit.slice().sort(frSort) };
    }

    function renderDrop(query) {
      var f = fold(query);
      var n = needs();
      var needC = n.corps.filter(function (x) { return !f || fold(x).indexOf(f) !== -1; });
      var needE = n.esprit.filter(function (x) { return !f || fold(x).indexOf(f) !== -1; });
      var stones = f ? stoneNames().filter(function (x) { return fold(x).indexOf(f) !== -1; }) : [];

      var h = '';
      if (stones.length) {
        h += '<div class="lp-drop__grp">Pierres</div>';
        stones.forEach(function (s) {
          h += '<button type="button" class="lp-drop__it" data-lp-stone="' + s.replace(/"/g, '&quot;') + '">' + s + '</button>';
        });
      }
      if (needC.length) {
        h += '<div class="lp-drop__grp">Besoins · Corps</div>';
        needC.forEach(function (x) {
          h += '<button type="button" class="lp-drop__it lp-drop__it--c" data-lp-need="' + x.replace(/"/g, '&quot;') + '" data-lp-kind="c">' + x + '</button>';
        });
      }
      if (needE.length) {
        h += '<div class="lp-drop__grp">Besoins · Esprit</div>';
        needE.forEach(function (x) {
          h += '<button type="button" class="lp-drop__it lp-drop__it--e" data-lp-need="' + x.replace(/"/g, '&quot;') + '" data-lp-kind="e">' + x + '</button>';
        });
      }
      drop.innerHTML = h || '<p class="lp-drop__none">Aucun résultat</p>';
      drop.hidden = false;
    }

    if (q && drop) {
      q.addEventListener('focus', function () { renderDrop(q.value); });
      q.addEventListener('input', function () { renderDrop(q.value); });
      modal.addEventListener('click', function (e) {
        if (!e.target.closest('.lp-search')) drop.hidden = true;
      });

      drop.addEventListener('click', function (e) {
        var st = e.target.closest('[data-lp-stone]');
        if (st) {
          drop.hidden = true;
          q.value = '';
          clearFilter();
          showPane('toutes');
          var row = listPane && listPane.querySelector('.bead-option[data-bead-name="' + st.dataset.lpStone.replace(/"/g, '\\"') + '"]');
          if (row) {
            row.click(); // sélection via bead-selector.js
            row.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
          return;
        }
        var nd = e.target.closest('[data-lp-need]');
        if (nd) {
          drop.hidden = true;
          q.value = '';
          applyNeedFilter(nd.dataset.lpNeed, nd.dataset.lpKind);
        }
      });
    }

    function showPane(name) {
      modal.querySelectorAll('.lp-tab').forEach(function (t) { t.classList.toggle('is-on', t.dataset.lpTab === name); });
      modal.querySelectorAll('.lp-pane').forEach(function (p) { p.hidden = p.dataset.lpPane !== name; });
    }

    function applyNeedFilter(need, kind) {
      showPane('toutes');
      var attr = kind === 'c' ? 'ailmentsCorps' : 'ailmentsEsprit';
      var count = 0;
      listPane.querySelectorAll('.bead-option').forEach(function (row) {
        var list = (row.dataset[attr] || '').split(',').map(function (x) { return x.trim(); });
        var hit = list.indexOf(need) !== -1;
        row.classList.toggle('lp-hidden', !hit);
        if (hit) count++;
      });
      filterbar.innerHTML =
        '<span class="lp-chip ' + (kind === 'c' ? 'lp-chip--c' : 'lp-chip--e') + ' lp-filterbar__chip">' + need + '</span>' +
        '<button type="button" class="lp-filterbar__clear" aria-label="Effacer le filtre">&times;</button>' +
        '<span class="lp-filterbar__count">' + count + ' pierre' + (count > 1 ? 's' : '') + ' conseillée' + (count > 1 ? 's' : '') + '</span>';
      filterbar.hidden = false;
      filterbar.querySelector('.lp-filterbar__clear').addEventListener('click', clearFilter);
    }

    function clearFilter() {
      filterbar.hidden = true;
      filterbar.innerHTML = '';
      listPane.querySelectorAll('.bead-option.lp-hidden').forEach(function (r) { r.classList.remove('lp-hidden'); });
    }

    // À l'ouverture de la modale : réinitialiser recherche/filtre/onglet
    var observer = new MutationObserver(function () {
      if (modal.open) {
        if (q) q.value = '';
        if (drop) drop.hidden = true;
        clearFilter();
        showPane('toutes');
        modal.querySelectorAll('.lp-need[open]').forEach(function (d) { d.removeAttribute('open'); });
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  // ------------------------------------------------- récaps des accordéons
  function setupRecaps() {
    function tailleRecap() {
      var b = document.querySelector('#beads-size-pills input:checked');
      var t = document.querySelector('#bracelet-size-pills input:checked');
      var el = document.querySelector('[data-lp-taille-recap]');
      if (el && b && t) el.textContent = b.value + ' · ' + t.value;
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest('#beads-size-pills') || e.target.closest('#bracelet-size-pills')) tailleRecap();
    });
    tailleRecap();

    document.addEventListener('beadSelectionChange', function (e) {
      var el = document.querySelector('[data-lp-pierres-recap]');
      if (!el) return;
      var beads = (e.detail && e.detail.beads) || {};
      var names = Object.keys(beads).sort().map(function (k) { return beads[k]; }).filter(Boolean);
      el.textContent = names.length ? names.join(', ') : 'Choisissez jusqu’à 4 pierres';
    });
  }

  // -------------------------------------- prix total dans le bouton panier
  function setupCtaPrice() {
    function update() {
      setTimeout(function () {
        var priceEl = document.querySelector('product-price [ref="priceContainer"] .price');
        if (!priceEl) return;
        var label = document.querySelector('form[action*="/cart/add"] .add-to-cart-text__content');
        if (!label) return;
        var span = label.querySelector('.lp-cta-price');
        if (!span) {
          span = document.createElement('span');
          span.className = 'lp-cta-price';
          label.appendChild(span);
        }
        span.textContent = ' · ' + priceEl.textContent.trim();
      }, 120);
    }
    document.addEventListener('beadSelectionChange', update);
    document.addEventListener('change', function (e) {
      if (e.target.closest('#beads-size-pills') || e.target.closest('#bracelet-size-pills')) update();
    });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
